import { INVESTOR_COUNTRIES } from '../constants/countries';

/** ISO-3166 alpha-2 codes for canonical investor country names. UK uses UK (not GB). */
const COUNTRY_ISO2: Record<string, string> = {
  Argentina: 'AR',
  Australia: 'AU',
  Austria: 'AT',
  Bahrain: 'BH',
  Belgium: 'BE',
  Brazil: 'BR',
  Bulgaria: 'BG',
  Canada: 'CA',
  Chile: 'CL',
  China: 'CN',
  Colombia: 'CO',
  Croatia: 'HR',
  'Czech Republic': 'CZ',
  Denmark: 'DK',
  Egypt: 'EG',
  Estonia: 'EE',
  Finland: 'FI',
  France: 'FR',
  Germany: 'DE',
  Greece: 'GR',
  'Hong Kong': 'HK',
  Hungary: 'HU',
  Iceland: 'IS',
  India: 'IN',
  Indonesia: 'ID',
  Ireland: 'IE',
  Israel: 'IL',
  Italy: 'IT',
  Japan: 'JP',
  Kenya: 'KE',
  Kuwait: 'KW',
  Latvia: 'LV',
  Liechtenstein: 'LI',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Malaysia: 'MY',
  Mexico: 'MX',
  Monaco: 'MC',
  Netherlands: 'NL',
  'New Zealand': 'NZ',
  Nigeria: 'NG',
  Norway: 'NO',
  Philippines: 'PH',
  Poland: 'PL',
  Portugal: 'PT',
  Qatar: 'QA',
  Romania: 'RO',
  Russia: 'RU',
  'Saudi Arabia': 'SA',
  Serbia: 'RS',
  Singapore: 'SG',
  Slovenia: 'SI',
  'South Africa': 'ZA',
  'South Korea': 'KR',
  Spain: 'ES',
  Sweden: 'SE',
  Switzerland: 'CH',
  Taiwan: 'TW',
  Thailand: 'TH',
  Turkey: 'TR',
  Ukraine: 'UA',
  'United Arab Emirates': 'AE',
  'United Kingdom': 'UK',
  'United States': 'US',
  Vietnam: 'VN',
};

const PASSTHROUGH_LABELS = new Set(['Unassigned', 'Other', 'Unknown']);

/** Ensure every canonical country has an abbreviation mapping. */
for (const country of INVESTOR_COUNTRIES) {
  if (!COUNTRY_ISO2[country]) {
    throw new Error(`Missing ISO-2 mapping for investor country: ${country}`);
  }
}

/**
 * Display abbreviation for summary tiles and tight UI. Does not mutate stored values.
 */
export function formatCountryAbbreviation(name: string): string {
  const trimmed = name.trim();
  if (!trimmed || PASSTHROUGH_LABELS.has(trimmed)) {
    return trimmed || name;
  }
  return COUNTRY_ISO2[trimmed] ?? trimmed;
}

/**
 * Full label for tooltips and accessibility when the visible value is abbreviated.
 */
export function getCountryDisplayTitle(name: string): string {
  const trimmed = name.trim();
  if (!trimmed || PASSTHROUGH_LABELS.has(trimmed)) {
    return trimmed || name;
  }
  return trimmed;
}
